import { render, staticRenderFns } from "./c27.vue?vue&type=template&id=cca2fe5e&scoped=true&"
import script from "./c27.vue?vue&type=script&lang=js&"
export * from "./c27.vue?vue&type=script&lang=js&"
import style0 from "./c27.vue?vue&type=style&index=0&id=cca2fe5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca2fe5e",
  null
  
)

export default component.exports